import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/1e48ac9e-9325-40ff-aa09-fb1663a7b919";
export const REGISTER_URL = "https://a.ntrk2.com/acc623ef-42ff-42e7-92ff-5820a92ea8f4";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://richbd.kzw2a.com/download?openExternalBrowser=1&id=jwvkv9ropi0lvac";

export * from "./codes";
export * from "./context";
